// socket.js
import { io } from 'socket.io-client';
import { Environment, isStagingV2 } from './constants/appConstants';
const baseUrl = () => {
  let BASE_URL = '';
  // Must track appConstants.baseUrl exactly. The socket carries document status
  // changes for the SAME session the REST calls authenticate, so a build whose
  // API points at one Tier B and whose socket points at another connects to a
  // server that has never heard of the user — and it fails silently, as a
  // notification panel that simply never updates.
  if (isStagingV2) {
    BASE_URL = 'https://stagingv2-backend.beiinghuman.com';
  } else if (Environment === 'Development') {
    BASE_URL = 'https://dev-api-v2.beinghumans.co';
  } else if (Environment === 'Production') {
    BASE_URL = 'https://api-v2.beiinghuman.com';
  } else if (Environment === 'Staging') {
    BASE_URL = 'https://staging-backend.beiinghuman.com';
  } else {
    BASE_URL = 'http://localhost:3000';
  }
  return BASE_URL;
};
const socket = io(baseUrl(), {
  autoConnect: false,
  transports: ['websocket']
});

export default socket;
